export default __webpack_public_path__ + "static/media/october-min.f4987ffa.jpg";